const state = () => ({
    vault: null,
})


const getters = {
    getVault() {
        return state.vault;
    },
};


// actions
const actions = {
    fetchVault({ commit, dispatch }, id) {
        commit('setVault', null);
        return new Promise((resolve, reject) => {
            dispatch("API", {
                url: `/api/vault_info/${id}`,
            }, { root: true })
                .then((result) => {
                    resolve(result);
                    commit("setVault", result);
                });
        });

    },
}


// mutations
const mutations = {
    setVault(state, value) {
        state.vault = value;
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
